/**
 * Product article group constants used for translation mapping.
 * Maps article group IDs to their corresponding translation keys.
 */
export const ARTICLE_GROUP_KEYS = {
  FAB: [3, 18], // navi_fab
  FGE: [4], // navi_fge
  PFB: [5], // navi_pfb
  PFK: [6], // navi_pfk
  FGK: [7, 13], // navi_fgk
  PWB: [10], // navi_pwb
  PHH: [30], // navi_phh
};

/**
 * Order status constants
 */
export const ORDER_STATUS = {
  INIT: 'INIT',
  SUBMITTED: 'SUBMITTED',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  UNKNOWN: 'UNKNOWN',
  DELIVERY_DATA_TRANSMITTED: 'DELIVERY_DATA_TRANSMITTED',
  DELIVERY_TRANSIT: 'DELIVERY_TRANSIT',
  DELIVERY_START: 'DELIVERY_START',
  DELIVERY_OUT_FOR_DELIVERY: 'DELIVERY_OUT_FOR_DELIVERY',
  DELIVERY_DELAY: 'DELIVERY_DELAY',
  DELIVERY_UNDELIVERABLE: 'DELIVERY_UNDELIVERABLE',
  DELIVERY_PICKUP: 'DELIVERY_PICKUP',
  RESHIPPED: 'RESHIPPED',
} as const;

/**
 * Error codes for order status operations
 */
export const ERROR_CODES = {
  NotFound: 10006,
  TooOld: 10180,
} as const;

/**
 * Order statuses that indicate the order has been shipped
 */
export const SHIPPED_STATES = [
  ORDER_STATUS.SHIPPED,
  ORDER_STATUS.DELIVERY_DATA_TRANSMITTED,
  ORDER_STATUS.DELIVERY_OUT_FOR_DELIVERY,
  ORDER_STATUS.DELIVERY_TRANSIT,
  ORDER_STATUS.DELIVERY_START,
  ORDER_STATUS.DELIVERY_DELAY,
  ORDER_STATUS.DELIVERY_UNDELIVERABLE,
  ORDER_STATUS.DELIVERY_PICKUP,
  ORDER_STATUS.RESHIPPED,
] as const;

export const TRACKING_LABEL: { [key: string | number]: string } = {
  [ORDER_STATUS.INIT]: 'Bestellung',
  [ORDER_STATUS.SUBMITTED]: 'Bestellung',
  [ORDER_STATUS.PROCESSING]: 'Druck',
  [ORDER_STATUS.SHIPPED]: 'Versand',
  [ORDER_STATUS.DELIVERED]: 'Zugestellt',
  [ORDER_STATUS.UNKNOWN]: 'Hold',
  PARTIALLY_SHIPPED: 'Teillieferung Versand',
  PARTIALLY_DELIVERED: 'Teillieferung Zugestellt',
  DELIVERY_OUT_FOR_DELIVERY: 'Versand',
  10006: 'too old',
  10180: 'not found',
};
